import { faLandmark } from "@fortawesome/free-solid-svg-icons";
import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { startEditElement } from "../../../actions/elementListAction";
import { DropdownOption } from "../../../models/dropdownOptionModel";
import { Element } from "../../../models/elementModel";
import { InputTypes } from "../../../utils/constants";
import ElementStyleProperties from "../common/elementStyleProperties";
import './elementProprtiesPanal.scss';
import Switch from "react-switch";
import { Accordion, Button, Card } from "react-bootstrap";
import { getDropDownElementsWithoutOwn } from "../../../selectors/elementListSelector";
import { AppState } from "../../../reducers/rootReducer";

export interface DropdownElementPropertiesProps {
  element: Element;
}

const DropdownProperties: FC<DropdownElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  const dropdownElementListI = useSelector((state: AppState) => state.elementList.present);
  let dropdownOption: DropdownOption[] = element.properties.options;

  const addNewOption = () => {
    let newDropdownOption: DropdownOption = { id: uuid(), value: '', valueText: '', disabled: false, selected: false, filterValue: '' };
    const newElement = produce(element, draft => { draft.properties.options.push(newDropdownOption) });
    dispatch(startEditElement(newElement));
  }

  const removeOption = (index: number) => {
    const newElement = produce(element, draft => { draft.properties.options.splice(index, 1) })
    dispatch(startEditElement(newElement));
  }

  const isSelectedValue = (x: DropdownOption[]) => {
    return x.findIndex(option => option.selected == true)
  }

  const renderDeropdownist = () => {
    let parentDropdowns = dropdownElementListI.filter(
      (dropdown: Element) => dropdown.type === 'dropdown' && dropdown.id !== element.id
    );
    return parentDropdowns.map((parent, i) => {
      return (
        <option key={i} value={`${parent.id}`}>
          {parent.name}
        </option>
      );
    });
  };

  const renderFilterValues = (id: String) => {
    let parentDropdowns = dropdownElementListI.filter(
      (dropdown: Element) => dropdown.type === 'dropdown' && dropdown.id === id
    )[0];

    if(parentDropdowns) {
      return parentDropdowns.properties.options.filter((op:DropdownOption)=>op.disabled !== true).map((option: DropdownOption, i: number) => {
        return (
          <option key={i} value={`${option.id}`}>
            {option.valueText}
          </option>
        );
      });
    }
  };

  return (
    <div className="container mt-3">
        <div className="form-group row">
          <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
            Name
          </label>
          <div className="col-sm-8">
            <input
              value={`${element.name}`}
              className="form-control theam-textbox items-align-left"
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.name = e.target.value})
                dispatch(startEditElement(newElement));
              }}
              type="text"
              id="elementName"
            />
          </div>

      </div>
      <div className="form-group row">
        <label htmlFor="required-field" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Required
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.required}
            onChange={() => {
              const newElement = produce(element, draft => {
                draft.properties.required = !draft.properties.required
              })
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
          />
        </div>
        {/* <div className="col-sm-12">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                {element.properties.required && (
                  <div className="form-group row">
                    <label
                      htmlFor="valid-message"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Valid Feedback
                    </label>
                    <div className="col-sm-8">
                      <input
                        value={element.properties.valid_feedback}
                        className="form-control theam-textbox items-align-left"
                        onChange={(e) => {
                          const newElement = produce(element, draft => { draft.properties.valid_feedback = e.target.value });
                          dispatch(startEditElement(newElement));
                        }}
                        type="text"
                        id="valid-message"
                      />
                    </div>
                  </div>
                )}
                {element.properties.required && (
                  <div className="form-group row">
                    <label
                      htmlFor="invalid-message"
                      className="col-sm-4 col-form-label font-size-12 align-text-left"
                    >
                      Invalid Feedback
                    </label>
                    <div className="col-sm-8">
                      <input
                        value={element.properties.invalid_feedback}
                        className="form-control theam-textbox items-align-left"
                        onChange={(e) => {
                          const newElement = produce(element, draft => { draft.properties.invalid_feedback = e.target.value });
                          dispatch(startEditElement(newElement));
                        }}
                        type="text"
                        id="invalid-message"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="form-group row">
        <label htmlFor="field-disabled" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Disable
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.disabled}
            onChange={() => {
              const newElement = produce(element, draft => {
                draft.properties.disabled = !draft.properties.disabled
              })
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="field-isDependant" className="col-sm-4 col-form-label font-size-12 align-text-left pr-0">
          Is Dependant
        </label>
        <div className="col-sm-2 mt-1">
          <Switch
            checked={element.properties.isDependant}
            onChange={() => {
              const newElement = produce(element, draft => {
                draft.properties.isDependant = !draft.properties.isDependant

                for(let i = 0; draft.properties.options.length > i; i++) {
                  draft.properties.options[i].selected = false;
                  draft.properties.options[i].disabled = false;
                }
              })
              dispatch(startEditElement(newElement));
            }}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={15}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={10}
            width={24}
            className="react-switch"
            id="required-field"
          />
        </div>
      </div>
      {element.properties.isDependant && (
        <div className="form-group row">
          <label htmlFor="parent-dropdown" className="col-sm-4 col-form-label font-size-12 align-text-left pr-0">
            Parent dropdown
          </label>
          <div className="col-sm-8">
            <select
              value={element.properties.parentDropdownId}
              id="parent-dropdown-id"
              className="form-control theam-textbox items-align-left"
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.parentDropdownId = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
            >
              <option key={0} value="">
                --Default--
              </option>
              {
                renderDeropdownist()
              }
            </select>
          </div>
        </div>
      )}
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <div className="form-group row">
        <label htmlFor="tooltip" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Tooltip
        </label>
        <div className="col-sm-8">
          <textarea className="form-control theam-textbox font-size-12 items-align-left" name="tooltip" id="tooltip" placeholder="Enter tooltip" cols={30} rows={2}
          value={element.properties.tooltip}
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.tooltip = e.target.value })
              dispatch(startEditElement(newElement));
            }}
          ></textarea>
        </div>
      </div>

      <Accordion defaultActiveKey="0">
            <Card className="theam-component">
              <Accordion.Toggle as={Button} variant="outline-dark" className="theam-font" eventKey="0">
                <div className="row">
                  <div className="col-sm-10">
                    Dropdown Options
                  </div>
                  <div className="col-sm-2">
                    <i className="fa fa-plus" onClick={(e)=>{
                      e.stopPropagation();
                      addNewOption();
                    }}></i>
                  </div>
                </div>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="0">
                <Card.Body className="padding-0 widh-a theam-card">
                {element.properties.options.map((option:DropdownOption,i:number) => {
              return(
                <div key={i}>
                  <div className="form-group row">
                      <label htmlFor="valueText" className="col-sm-4 col-form-label font-size-12 align-text-left">
                        Text Value
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control theam-textbox items-align-left mt-1"
                          id="valueText"
                          placeholder="Add Option Text Value"
                          value={option.valueText}
                          onChange={(e)=>{
                            const newElement = produce(element, draft =>{draft.properties.options[i].valueText = e.target.value})
                            dispatch(startEditElement(newElement));
                          }}
                        />
                      </div>
                      <div className="col-sm-2 mt-1 padding-left-inherit">
                        <button type="button" className="btn btn-dark btn-sm btn-theam" onClick={(e)=> {removeOption(i)}}> <i className="fa fa-minus"></i></button>
                    </div>
                  </div>
                  <div className="form-group row">
                    {!(element.properties.isDependant && element.properties.parentDropdownId !== '') && (
                      <>
                                              <label htmlFor="valueText" className="col-sm-4 col-form-label font-size-12 align-text-left">
                        Default
                      </label>
                      <div className="col-sm-2 align-text-left padding-left-inherit mt-1">
                        <Switch
                          checked={option.selected}
                          onChange={(e) =>{
                            const newElement = produce(element, draft => {
                              if(isSelectedValue(dropdownOption) != -1){
                                draft.properties.options[isSelectedValue(dropdownOption)].selected = false;
                              }
                              draft.properties.options[i].selected = e;
                              })
                            dispatch(startEditElement(newElement));
                          }}
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={15}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={10}
                          width={24}
                          className="react-switch"
                        />
                      </div>  
                      <label htmlFor="valueText" className="col-sm-4 col-form-label font-size-12 align-text-left">
                        Disabled
                      </label>
                      <div className="col-sm-2 align-text-left padding-left-inherit mt-1">
                        <Switch
                          checked={option.disabled}
                          onChange={(e) =>{
                            const newElement = produce(element, draft => {draft.properties.options[i].disabled = e})
                            dispatch(startEditElement(newElement));
                          }}
                          onColor="#86d3ff"
                          onHandleColor="#2693e6"
                          handleDiameter={15}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={10}
                          width={24}
                          className="react-switch"
                        />
                      </div>
                      </>
                    )}

                      {(element.properties.isDependant && element.properties.parentDropdownId !== '') && (
              // <div className="form-group row">
              <>
                <label htmlFor="filterValue" className="col-sm-4 col-form-label font-size-12 align-text-left">
                  Filter Value
                </label>
                <div className="col-sm-6">
                  <select
                    value={option.filterValue}
                    id="filterValue-id"
                    className="form-control theam-textbox items-align-left mt-1"
                    onChange={(e) => {
                      const newElement = produce(element, (draft) => {
                        draft.properties.options[i].filterValue = e.target.value;
                      });
                      dispatch(startEditElement(newElement));
                    }}
                  >
                    <option key={0} value="">
                      --Default--
                    </option>
                    {
                      renderFilterValues(element.properties.parentDropdownId)
                    }
                  </select>
                </div>
 </>
              // </div>
            )}
                  </div>
                  <hr style={{margin: 0}}/>
                </div>
              );
            })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
    </div>
  );
};

export default DropdownProperties